import React, { useState } from 'react';
import { Card, Form, Input, Button, Alert, Typography } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { login, setToken } from './api';
import Footer from './Footer';

const { Title, Text } = Typography;

// Same variable the two tenant frontends use for their branding, so all three
// sites are configured the same way. The default is the Sealanie Group mark —
// the one RBS already ships — because this dashboard covers the group rather
// than either company. Point REACT_APP_LOGO_URL elsewhere to change it; no code
// edit needed.
const LOGO_URL = process.env.REACT_APP_LOGO_URL
  || 'https://sealaniegroup.lk/wp-content/uploads/2022/01/group-logo-color.png';

export default function Login({ onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const onFinish = async ({ username, password }) => {
    setLoading(true);
    setError(null);
    try {
      const res = await login(username, password);
      setToken(res.accessToken);
      onSuccess();
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column',
                  alignItems: 'center', justifyContent: 'center',
                  background: '#f0f2f5', padding: 16 }}>
      <Card style={{ width: '100%', maxWidth: 380 }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          {/* Remotely hosted, like the tenant apps' logo. If it fails to load
              the element removes itself rather than leaving a broken-image icon
              above the password field — the sign-in has to keep working when
              the marketing site does not. */}
          <img
            src={LOGO_URL}
            alt=""
            style={{ maxWidth: 180, maxHeight: 64, objectFit: 'contain', marginBottom: 12 }}
            onError={(e) => { e.currentTarget.style.display = 'none'; }}
          />
          <Title level={3} style={{ marginBottom: 4 }}>SLB Dashboard</Title>
          <Text type="secondary">Group overview</Text>
        </div>

        {error && <Alert type="error" message={error} showIcon style={{ marginBottom: 16 }} />}

        <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
          <Form.Item name="username" label="Username"
                     rules={[{ required: true, message: 'Username is required' }]}>
            <Input prefix={<UserOutlined />} placeholder="Enter username" autoComplete="username" />
          </Form.Item>
          <Form.Item name="password" label="Password"
                     rules={[{ required: true, message: 'Password is required' }]}>
            <Input.Password prefix={<LockOutlined />} placeholder="Enter password"
                            autoComplete="current-password" />
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>Sign In</Button>
        </Form>
      </Card>
      <div style={{ width: '100%', maxWidth: 380 }}>
        <Footer />
      </div>
    </div>
  );
}
